import React, { useEffect } from 'react';
import { axiosClient } from '@app/configure-app';
import { SectionLabel } from '@atomic/v3';
import { ChallengeItemV3 } from './challenge-item-v3.component';
import { ChallengesContainer, Status } from './challenges-v3.component.style';
var GROUP_ENDPOINT_URL = 'filial/cursos-filias';
// Mesmos dados e endpoint do CourseLibraryList, com o visual V3.
export var ChallengeListV3 = function () {
    var _a = React.useState(), groups = _a[0], setGroups = _a[1];
    var _b = React.useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var _c = React.useState(false), isError = _c[0], setIsError = _c[1];
    useEffect(function () {
        if (!groups) {
            setIsLoading(true);
            axiosClient
                .get(GROUP_ENDPOINT_URL)
                .then(function (_a) {
                var coursesGroupsResponse = _a.data;
                setGroups(coursesGroupsResponse === null || coursesGroupsResponse === void 0 ? void 0 : coursesGroupsResponse.data);
            })
                .catch(function (error) {
                console.log(error);
                setIsError(true);
            })
                .finally(function () {
                setIsLoading(false);
            });
        }
    }, [groups]);
    return (React.createElement(ChallengesContainer, null,
        isLoading && React.createElement(Status, null, "Carregando..."),
        isError && React.createElement(Status, null, "Erro ao processar sua solicita\u00E7\u00E3o. Recarregue a p\u00E1gina e tente novamente"), groups === null || groups === void 0 ? void 0 :
        groups.map(function (group, idx) { return (React.createElement(React.Fragment, { key: idx },
            React.createElement(SectionLabel, null, group.nome),
            group.cursos.concat(group.cursosSequencias).map(function (course, idxCourse) { return (React.createElement(ChallengeItemV3, { key: idxCourse, course: course, courseIndex: idxCourse })); }))); })));
};
